import { useEffect } from 'react';

const useActionNetworkForm = (form) => {
  useEffect(() => {
    if (!form) return;

    const { sourceUrl, cssLink, containerElementId } = form;
    const child = document.getElementById(containerElementId);

    if (!child || !sourceUrl) return;

    let link = null;
    if (cssLink) {
      link = document.createElement('link');
      link.href = cssLink;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      document.head.appendChild(link);
    }

    const script = document.createElement('script');
    script.src = sourceUrl;
    script.async = true;
    child.appendChild(script);

    return () => {
      if (link && link.parentNode && link.parentNode.removeChild) {
        link.parentNode.removeChild(link);
      }

      if (script && script.parentNode && script.parentNode.removeChild) {
        script.parentNode.removeChild(script);
      }
    };
  }, [form]);

  return { formId: form?.containerElementId };
};

export default useActionNetworkForm;
